import React, { useState } from 'react'
import { RiSearchLine } from "react-icons/ri";
import { motion, AnimatePresence } from 'framer-motion'
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../helpers/Axios';
import { Oval } from 'react-loader-spinner';
import { displayImage } from '../../helpers/config';
import FormatCurrency from '../../helpers/FormatCurrency';
import { IoClose } from 'react-icons/io5';
import Wrapper from '../../helpers/Wrapper';
import Overlay from '../Overlay';
import { useNavigate } from 'react-router-dom';

function SearchPlace({ isOpen, callback }) {

    const [searchInput, setSearchInput] = useState("")
    const navigate = useNavigate()


    const { data: products, isLoading } = useQuery({
        queryKey: ['search', searchInput],
        queryFn: async () => {
            const res = await apiClient.get('/search/live', { params: { searchInput } })
            return res.data
        },
        enabled: searchInput.length > 0,
        staleTime: 5000
    })



    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <div className="relative w-full">
                        {/* Overlay */}
                        <Overlay onClick={() => callback()} />
                        {/* Contents */}
                        <motion.div
                            initial={{ y: -500 }}
                            animate={{ y: 0 }}
                            exit={{ y: -500 }}
                            transition={{ duration: 0.4 }}
                            className="fixed top-0 left-0 w-full py-10 z-50 bg-white pb-16 scroll-container"
                        >
                            <Wrapper>
                                <div className="flex justify-end">
                                    <button onClick={() => callback()}>
                                        <IoClose size={25} />
                                    </button>
                                </div>

                                {/* Input search */}
                                <div className="w-full py-3">
                                    <div className="mx-auto max-w-3xl">
                                        <h1 className="text-center text-xl sm:text-3xl font-medium">
                                            Search Our Site
                                        </h1>

                                        <div className="mt-5 relative">
                                            <input
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                value={searchInput}
                                                type="text"
                                                placeholder="I'm looking for..."
                                                className="w-full outline-none rounded-full py-3.5 border focus:border-black px-7"
                                            />
                                            {isLoading && (
                                                <div className="absolute top-1/2 -translate-y-1/2 right-14">
                                                    <Oval width={16} height={16} strokeWidth={5} />
                                                </div>
                                            )}
                                            <div className="absolute top-1/2 -translate-y-1/2 right-6">
                                                <button onClick={() => {
                                                    if (searchInput?.length > 0) {
                                                        navigate(`/search?query=${searchInput}`)
                                                        callback()
                                                    }
                                                }}>
                                                    <RiSearchLine size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* Data Place */}
                                {products?.length > 0 ? (
                                    <div className="w-full h-screen overflow-y-auto ">
                                        {/* Serach Live */}
                                        <div className="mt-6">
                                            <div className="text-[clamp(1rem,2vw+1rem,1.5rem)] text-gray-400 flex gap-2 justify-center">
                                                Search for <p className='text-black'>"{searchInput}"</p>
                                            </div>
                                        </div>

                                        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-5 overflow-y-auto">
                                            {products?.map((product, i) => (
                                                <a href={`${product?.slug}`} key={i}>
                                                    <div className="w-full space-y-3">
                                                        {/* Image */}
                                                        <div className="w-full relative overflow-hidden pt-[120%] rounded-xl">
                                                            <img
                                                                loading='lazy'
                                                                className='absolute top-0 left-0 bottom-0 right-0 w-full h-full object-cover'
                                                                src={displayImage(JSON.parse(product?.images)[0])} alt=""
                                                            />
                                                        </div>

                                                        {/* Content */}
                                                        <div className='w-full'>
                                                            <h3 className='text-[clamp(0.9rem,2vw+1rem,1.1rem)] truncate'>{product?.name}</h3>
                                                            <div className='text-[clamp(0.9rem,2vw+1rem,0.9rem)] text-gray-600'>
                                                                <FormatCurrency amount={product?.base_price} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                ) : searchInput && products?.length < 1 && (
                                    <div className="mt-8">
                                        <div className="text-[clamp(1rem,2vw+1rem,1.5rem)] text-gray-400 flex gap-2 justify-center">
                                            Nothing matches your search <p className='text-black'>"{searchInput}"</p>
                                        </div>
                                    </div>
                                )}
                            </Wrapper>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </>
    )
}

export default SearchPlace